import Vue from 'vue';
Vue.directive('el-select-load-more', (el, binding) => {
  const SELECT_WRAP_DOM = el.querySelector(
    '.el-select-dropdown .el-select-dropdown__wrap'
  )
  if (SELECT_WRAP_DOM) {
    SELECT_WRAP_DOM.addEventListener('scroll', function () {
      const condition =
        this.scrollHeight - this.scrollTop <= this.clientHeight
      if (condition) {
        binding.value()
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/until/directives.js